<template>
	<div
		class="c-search-text-input"
		:class="dimmed && 'c-search-text-input--dimmed'"
	>
		<input
			v-bind="$attrs"
			v-model="computedValue"
			:aria-label="computedLabel || null"
			:type="type"
			class="
				flex-shrink flex-grow
				w-full
				h-full
				pl-sm/h
				py-20
				text-input text-theme
				bg-transparent
			"
			:class="{
				'pr-sm/h': !$slots.default,
				'placeholder-theme-80': dimmed,
				'placeholder-gray-dark': !dimmed,
			}"
			v-on="computedListeners"
		/>

		<!-- Add buttons to the end -->
		<div
			v-if="$scopedSlots.default"
			class="
				flex-shrink-0 flex-grow-0 flex
				items-center
				gap-8
				w-auto
				h-full
				p-8
			"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SearchTextInput',
	inheritAttrs: false,

	props: {
		type: {
			type: String,
			default: 'text',
		},
		value: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: null,
		},
		dimmed: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		computedValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},

		computedLabel() {
			return typeof this.label === 'string'
				? this.label
				: this.$attrs.placeholder;
		},

		computedListeners() {
			const listeners = {
				...this.$listeners,
			};
			delete listeners.input;
			return listeners;
		},
	},
};
</script>

<style lang="postcss">
.c-search-text-input {
	@apply w-full h-auto flex items-center rounded-full bg-white;

	& > * {
		@apply flex-shrink-0 flex-grow-0;
	}
}
.c-search-text-input--dimmed {
	@apply bg-theme-10;
}
</style>
